"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Checkbox = function (_a) {
    var id = _a.id, name = _a.name, children = _a.children, checked = _a.checked, onChange = _a.onChange;
    return react_1.default.createElement("div", { className: 'storybook-forms-checkbox' },
        react_1.default.createElement("div", { className: 'storybook-forms-checkbox-input' },
            react_1.default.createElement("input", { id: id, name: name, type: 'checkbox', checked: checked, onChange: function (event) { return onChange(event.target.checked); } })),
        children && react_1.default.createElement("div", { className: 'storybook-forms-checkbox-label' },
            react_1.default.createElement("label", { htmlFor: id }, children)));
};
exports.Checkbox = Checkbox;
exports.Checkbox.propTypes = {
    /**
     * The id of the Checkbox
     */
    id: prop_types_1.default.string,
    /**
     * The name of the Checkbox
     */
    name: prop_types_1.default.string,
    /**
     * The label of the Checkbox
     */
    children: prop_types_1.default.any,
    /**
     * The value of the Checkbox
     */
    value: prop_types_1.default.bool,
    /**
     * The onClick function of the Checkbox
     */
    onClick: prop_types_1.default.string,
};
exports.Checkbox.defaultProps = {};
